var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuciIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.394,
    height: 44.373,
    viewBox: "0 0 44.394 44.373",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331",
    transform: "translate(-122 -137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M34.538,6.409a1,1,0,0,0,.707-.293L41.36,0H29.442A1,1,0,0,0,28.735.3L24.7,4.333a1,1,0,0,1-1.416,0L19.244.295A1,1,0,0,0,18.536,0H6.618l6.116,6.116a1,1,0,0,0,.708.293Z",
    transform: "translate(120.027 137)",
    fill: "#00da1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M13.714,54.093a1,1,0,0,0-.707.293L6.892,60.5H18.81a1,1,0,0,0,.707-.293l4.037-4.037a1,1,0,0,1,1.416,0l4.038,4.038a1,1,0,0,0,.708.293H41.634l-6.116-6.116a1,1,0,0,0-.708-.293Z",
    transform: "translate(119.945 120.87)",
    fill: "#00da1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M54.123,34.721a1,1,0,0,0,.293.707l6.114,6.114V29.625a1,1,0,0,0-.293-.707L56.2,24.881a1,1,0,0,1,0-1.416l4.038-4.038a1,1,0,0,0,.293-.708V6.8l-6.116,6.116a1,1,0,0,0-.293.708Z",
    transform: "translate(105.862 134.972)",
    fill: "#00da1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M6.409,13.76a1,1,0,0,0-.293-.707L0,6.938V18.856a1,1,0,0,0,.293.707L4.333,23.6a1,1,0,0,1,0,1.416L.295,29.054A1,1,0,0,0,0,29.762V41.68l6.116-6.116a1,1,0,0,0,.293-.708Z",
    transform: "translate(122 134.931)",
    fill: "#00da1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M38.877,38.247V14.162a.615.615,0,0,0-.615-.615H14.176a.615.615,0,0,0-.615.615V38.247a.615.615,0,0,0,.615.615H38.262a.615.615,0,0,0,.615-.615m-4.134-8.276a9.389,9.389,0,1,1,.8-3.788,9.416,9.416,0,0,1-.8,3.788",
    transform: "translate(117.956 132.96)",
    fill: "#00da1a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuciIcon);
export default __webpack_public_path__ + "static/media/luci_icon.b65a27a83e3d749fd45c620097f4615c.svg";
export { ForwardRef as ReactComponent };